module.exports = __webpack_public_path__ + "img/icon-delete.82e0ed48.png";